module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-1"
    }
  }, [_vm._v("The Point in the Market")]), _vm._v(" "), _c('p', {
    staticClass: "Book-Subtitle",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("A Mamur Zapt Mystery")]), _vm._v(" "), _c('p', {
    staticClass: "Book-Author",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Michael Pearce")]), _vm._v(" "), _c('p', {
    staticClass: "Book-Publisher para-style-override-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Poisoned Pen Press")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Center"
  }, [_c('span', [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "29375.png",
      "src": "image/29375.png"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a896a020","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Point_in_the_Market.vue
// module id = 54
// module chunks = 0